import styled from 'styled-components';
import Colors from 'assets/Colors';

const Container = styled.div`
  width: 97%;
  margin: 0 auto;
  padding-right: 1px;
  max-width: 100vw;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const PageDateContainer = styled.div`
  font-size: 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  color: ${Colors.text_secondary};
`;

const textElement = styled.div`
  font-size: 12px;
  font-weight: 300;
  line-height: 21px;
  color: ${Colors.text_secondary};
`;

const ResultsContainer = styled.div`
  display: flex;
  margin-right: 70px;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  @media (max-width: 768px) {
    margin-right: 10px;
  }
`;

const IconWrapper = styled.div`
  cursor: pointer;
`;

export default {
  Container,
  PageDateContainer,
  ResultsContainer,
  IconWrapper,
  textElement,
};
